import { FC, ReactElement, memo } from 'react';
import { localeStore } from '~/mobx/localesStore';
import { IProductV4Modifier } from '~/types/product';
import { getTranslate } from '~/utils/helpers';
import './style.scss';

interface IProps {
  modifier: IProductV4Modifier;
}

export const MealItemMdfExclModalModifier: FC<IProps> = memo(({ modifier }: IProps): ReactElement => {
  return (
    <div className="meal-item-mdf-excl-modal-modifier">
      <p className="meal-item-mdf-excl-modal-modifier__name">{getTranslate(modifier.name)}</p>

      <div className="meal-item-mdf-excl-modal-modifier__options">
        <p className="meal-item-mdf-excl-modal-modifier__options-title letter-spacing-12">
          {localeStore.t('cm_config_page_show_modifiers_and_exclusions_popup_options_title')}
        </p>

        {modifier.options.map((option) => (
          <span key={option.id} className="meal-item-mdf-excl-modal-modifier__option">
            {getTranslate(option.name)}
          </span>
        ))}
      </div>
    </div>
  );
});
